$(document).ready(function(){

 


  setTimeout(function(){
    var cookies = document.cookie.split(';');
    var popupOpened = 0;
    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i].trim();
        console.log(cookie, 'COOKIES');
      if (cookie.indexOf('popupOpened=1') === 0) {
        popupOpened = 1
      }
    }
    if (popupOpened == 0){
      document.cookie = "popupOpened=1; expires=Thu, 1 Jul 2025 00:00:00 UTC; path=/";
      $('.spt_trigger').trigger('click');
    }
    
  },15000);
  
    
      $('.Sticky_announcment_bar_text').addClass('loaded');
    function checkingForDiscounts(){
        var checkingTrigger = $('#autofill_bar').html();
        // console.log(checkingTrigger);
        if (typeof(checkingTrigger) != 'undefined'){
          $('.Sticky_announcment_bar_outer').hide();
        }
      }
    
      setInterval(function(){
        checkingForDiscounts();
      },1000); 

  function checkingForDiscounts(){
    var checkingTrigger = $('#autofill_bar').html();
    // console.log(checkingTrigger);
    if (typeof(checkingTrigger) != 'undefined'){
      $('.Sticky_announcment_bar_outer').hide();
    }
  }

  setInterval(function(){
    checkingForDiscounts();
  },1000);

  
 
  
});
